import { render, staticRenderFns } from "./Cancellation.vue?vue&type=template&id=443b9480&"
import script from "./Cancellation.vue?vue&type=script&lang=js&"
export * from "./Cancellation.vue?vue&type=script&lang=js&"
import style0 from "./Cancellation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
